import { Select, DatePicker, Button, Input, Checkbox, message } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import Refresh from '@/assets/images/refresh.png'
import Shape2 from '@/assets/images/shape2.png'
import React, { memo, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SelectOption from '../Select'
import styles from './index.module.scss'
import dayjs from 'dayjs'
import { threeMonth, format, dateSelectLimit } from '@/constants'
import MyModal from '@/components/Modal'
import ExportHistory from '../../components/ExportHistory'
import { useSelector } from 'react-redux'
import { AppState } from '@/store/types'
import { WorkspaceMemberModel } from '@/services/apis/user/model'
import TxRecordApi from '@/services/apis/history/TxRecords'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import cacheUtil, { CACHE_HIDE_SMALL_AMOUNT } from '@/utils/cache'
import { formatTime, getEndTimestampFromDate, getStartTimestampFromDate } from '@/utils/number'
import txRecord from '@/services/apis/txRecord'
interface headerProps {
  type: 'Tx' | 'Mpc' | 'Web3'
  queryParam: any
  setQueryParam: Function
  condition: {
    statusList?: any
    accountList?: any
    networkList?: any
    userList?: any
    coinKey?: any
  }
  tableLoading: boolean
  accountName?: string | null
  setAccountName?: Function
}
const Header = memo<headerProps>(
  ({ type, queryParam, setQueryParam, condition, tableLoading, accountName, setAccountName }) => {
    const { t } = useTranslation()
    const { RangePicker } = DatePicker

    const { Search } = Input

    const userInfo = useSelector<AppState, WorkspaceMemberModel>(state => {
      return state.user.userInfo as any
    })
    const enterButton = (
      <Button style={{ width: '90px', height: '40px' }} type="primary">
        {t('common.search')}
      </Button>
    )
    // 日期组件
    const [date, setDate] = useState([dayjs(Date.now() - threeMonth), dayjs()])

    // 日期组件发生变化
    function handleDataChange(date: any, dateString: [string, string]) {
      const [startDate, endDate] = dateString
      // 改为用户时区
      let startTime = getStartTimestampFromDate(startDate)
      let endTime = getEndTimestampFromDate(endDate)
      // 传递的参数
      if (type === 'Mpc') {
        setQueryParam({ ...queryParam, startTime, endTime })
      } else {
        setQueryParam({ ...queryParam, minTime: startTime, maxTime: endTime })
      }

      if (!date) return
      if (endTime - startTime > dateSelectLimit) {
        if (type === 'Mpc') {
          setQueryParam({
            ...queryParam,
            startTime: getStartTimestampFromDate(endDate) - dateSelectLimit,
            endTime: endTime,
          })
        } else {
          setQueryParam({
            ...queryParam,
            minTime: getStartTimestampFromDate(endDate) - dateSelectLimit,
            maxTime: endTime,
          })
        }

        setDate([dayjs(formatTime(endDate) - dateSelectLimit), dayjs(formatTime(endDate))])
        message.error(t('record.dateSelectLimit'))
      } else {
        setDate([dayjs(formatTime(startDate)), dayjs(formatTime(endDate))])
      }
    }

    // 通用方法改变搜索参数
    function handleChangeStatus(value: string, e: any, status: string) {
      queryParam[status] = value

      if (status === 'accountKey') {
        setAccountName && setAccountName(value)
      }
      const DateList = { ...queryParam }

      setQueryParam(DateList)
    }

    // 导出历史模态框
    function handleExport() {
      MyModal.info({
        width: 680,
        closable: true,
        title: t('record.exportHistory'),
        footer: null,
        content: <ExportHistory />,
      })
    }
    async function exportRecord(close: Function) {
      ModalRef.current.update({
        okButtonProps: { disabled: true },
      })

      const res = await TxRecordApi.exportRecord(queryParam)
      ModalRef.current.update({
        okButtonProps: { disabled: false },
      })
      close()
      if (res.success) {
        message.success({
          type: 'success',
          content: t('record.exportSuccess'),
        })
      }
    }
    // 导出确定模态框
    const ModalRef = useRef<any>()
    function handleHistory() {
      const startTime = dayjs(queryParam.minTime).format(format)
      const endTime = dayjs(queryParam.maxTime).format(format)
      ModalRef.current = MyModal.confirm({
        title: t('record.exportConfirm'),
        content: t('record.exportConfirmContent', {
          workspace: userInfo?.workspaceName,
          startTime: startTime,
          endTime: endTime,
        }),
        onOk: exportRecord,
        okButtonProps: { disabled: false },
      })
    }
    function handleChangeHide(e: CheckboxChangeEvent) {
      const val = e.target.checked
      cacheUtil.set(`${CACHE_HIDE_SMALL_AMOUNT}${userInfo?.userKey}`, val ? 1 : 0)
      queryParam.hideSmallAmount = val
      setQueryParam({ ...queryParam })
    }
    const [smallAmount, setSmallAmount] = useState('0')
    useEffect(() => {
      if (type === 'Tx') {
        txRecord.getSmallAmountConfig().then(res => {
          setSmallAmount(res.data)
        })
      }
    }, [type])

    // 小额记录隐藏
    function handleHide() {
      MyModal.info({
        title: t('record.hideSmallAmountTitle'),
        content: (
          <div style={{ margin: '0 0 20px 55px' }}>
            {t('record.hideSmallAmountDesc', { x: smallAmount })}
          </div>
        ),
      })
    }

    // 处理前三个月后三个月
    const pickerRef = useRef<any>(null)
    function handleMonths(status: 1 | 0) {
      if (status) {
        if (type === 'Mpc') {
          setDate([
            dayjs(queryParam.startTime).add(-3, 'month'),
            dayjs(queryParam.endTime).add(-3, 'month'),
          ])
          setQueryParam({
            ...queryParam,
            startTime: +dayjs(queryParam.startTime).add(-3, 'month'),
            endTime: +dayjs(queryParam.endTime).add(-3, 'month'),
          })
        } else {
          setDate([
            dayjs(queryParam.minTime).add(-3, 'month'),
            dayjs(queryParam.maxTime).add(-3, 'month'),
          ])
          setQueryParam({
            ...queryParam,
            minTime: +dayjs(queryParam.minTime).add(-3, 'month'),
            maxTime: +dayjs(queryParam.maxTime).add(-3, 'month'),
          })
        }
      } else {
        if (type === 'Mpc') {
          setDate([
            dayjs(queryParam.startTime || date[0]).add(3, 'month'),
            dayjs(queryParam.endTime || date[1]).add(3, 'month'),
          ])
          setQueryParam({
            ...queryParam,
            startTime: +dayjs(queryParam.startTime).add(3, 'month'),
            endTime: +dayjs(queryParam.endTime).add(3, 'month'),
          })
        } else {
          setDate([
            dayjs(queryParam.minTime || date[0]).add(3, 'month'),
            dayjs(queryParam.maxTime || date[1]).add(3, 'month'),
          ])
          setQueryParam({
            ...queryParam,
            minTime: +dayjs(queryParam.minTime).add(3, 'month'),
            maxTime: +dayjs(queryParam.maxTime).add(3, 'month'),
          })
        }
      }
      pickerRef.current.blur()
    }
    return (
      <div className={styles.container}>
        {/* 头部选择框 */}
        <div className={styles.header}>
          <div className={styles.left}>
            <RangePicker
              value={[date[0], date[1]]}
              allowClear={false}
              onChange={handleDataChange}
              size="large"
              ref={pickerRef}
              renderExtraFooter={() => (
                <div className={styles.months}>
                  <Button
                    type="link"
                    style={{ marginRight: '10px' }}
                    onClick={() => handleMonths(1)}
                  >
                    {t('common.firstThreeMonths')}
                  </Button>
                  <Button
                    type="link"
                    onClick={() => handleMonths(0)}
                    disabled={+dayjs(queryParam.maxTime).add(3, 'month') >= +dayjs()}
                  >
                    {t('common.nextThreeMonths')}
                  </Button>
                </div>
              )}
              disabledDate={(current: any) => current?.isAfter(dayjs())}
            />
            <SelectOption
              list={condition?.statusList}
              type={type === 'Mpc' ? 'transactionStatus' : 'txStatus'}
              handleSetDate={handleChangeStatus}
            />

            {type !== 'Web3' ? (
              <Select
                style={{ width: 120, marginLeft: '10px' }}
                fieldNames={{ label: 'desc', value: 'key' }}
                options={condition?.accountList}
                onChange={(value: any, target: any) => {
                  handleChangeStatus(value, target, 'accountKey')
                }}
                suffixIcon={
                  <img src={Shape2} alt="" style={{ width: '12px', height: 'auto' }}></img>
                }
                value={accountName}
              />
            ) : (
              <SelectOption
                list={condition?.accountList}
                type="accountKey"
                handleSetDate={handleChangeStatus}
              />
            )}
            {type !== 'Mpc' && (
              <SelectOption
                list={condition?.networkList}
                type="network"
                handleSetDate={handleChangeStatus}
              />
            )}
            {type === 'Tx' && (
              <SelectOption
                list={condition?.coinKey}
                type="coinKey"
                handleSetDate={handleChangeStatus}
              />
            )}
            <SelectOption
              list={condition?.userList}
              type={type === 'Mpc' ? 'createdByKey' : 'createUserId'}
              handleSetDate={handleChangeStatus}
            />
            <Button
              style={{ marginLeft: '20px', cursor: 'pointer' }}
              onClick={() => {
                setQueryParam({
                  ...queryParam,
                })
              }}
              disabled={tableLoading}
              type="link"
            >
              <img src={Refresh} style={{ width: '14px', height: '14px' }} alt=""></img>
              <span style={{ marginLeft: '5px', color: '#12B89A', paddingBottom: '1px' }}>
                {t('common.refresh')}
              </span>
            </Button>
          </div>
          {type === 'Tx' && (
            <div className={styles.right}>
              <Button type="link" className={styles.link} onClick={handleExport}>
                {t('record.exportHistory')}
              </Button>
              <Button type="primary" className={styles.export} onClick={handleHistory}>
                {t('record.export')}
              </Button>
            </div>
          )}
        </div>
        {/* input选择框 */}
        <div className={styles.footer}>
          {type === 'Mpc' ? (
            <Search
              placeholder={t('record.platformId') as string}
              enterButton={enterButton}
              size="small"
              style={{ width: '550px' }}
              onSearch={(value, event) => {
                handleChangeStatus(value, event, 'txKey')
              }}
            />
          ) : (
            <Search
              placeholder={t('record.addressTnx') as string}
              enterButton={enterButton}
              size="small"
              style={{ width: '550px' }}
              onSearch={(value, event) => {
                handleChangeStatus(value, event, 'condition')
              }}
            />
          )}
          {type === 'Tx' && (
            <div className={styles.minText}>
              <Checkbox checked={queryParam.hideSmallAmount} onChange={handleChangeHide}>
                {t('record.hideSmallAmount')}
              </Checkbox>
              <QuestionCircleOutlined onClick={handleHide} />
            </div>
          )}
        </div>
      </div>
    )
  }
)

export default Header
